export default __webpack_public_path__ + "7695ae7ce6acb136411ccba34ae63055.png";